import React, { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import _find from 'lodash/find';
import { useLifeCycleEventBus } from '@thd-olt-functional/utils';
import { usePromoStore, useProductDataStore, useDigitalDataStore } from '../store';
import { useDesignStore } from '../store/design/context';
import useTotalPriceAndFulfillment from '../hooks/useTotalPriceAndFulfillment';
import usePriceAdjustment from '../hooks/usePriceAdjustment';
import usePromoProducts from '../hooks/usePromoProducts';
import usePromoCustomData from '../hooks/usePromoCustomData';

// promo utils

const PromotionsProvider = () => {

  // product data store (aka graphQL data)
  const storeProductData = useProductDataStore((state) => state.productData);

  // promo store
  const resetPromoItems = usePromoStore((state) => state.resetPromoItems);
  const promoData = usePromoStore((state) => state.promo);

  // design store
  const products = useDesignStore((state) => state.design.products);
  const cart = useDesignStore((state) => state.design.cart);

  const promoItemData = useLifeCycleEventBus('promotion-products.items-to-add-to-cart');

  const addNonVisualizedProduct = useDesignStore((state) => state.addNonVisualizedProduct);

  // handleTotalPrice converted to useMemo
  useTotalPriceAndFulfillment();
  usePriceAdjustment();

  const trackAddItemToStackEvent = useDigitalDataStore((state) => state.trackAddItemToStackEvent);

  useEffect(() => {
    const hasPromoTest = _find(
      [...cart, ...products],
      (item) => !_isEmpty(storeProductData?.[item.Sku]?.pricing?.conditionalPromotions)
    );
    if (!_isEmpty(promoData)) {
      if (hasPromoTest) {
        _map(
          promoItemData?.data,
          (promoItemId) => {
            addNonVisualizedProduct(promoItemId);
            trackAddItemToStackEvent(promoItemId, storeProductData?.[promoItemId]?.pricing?.value);
          }
        );
        return () => false;
      }
      return resetPromoItems();
    }
    return () => false;
  }, [promoItemData?.data]);

  const [itemIds] = usePromoProducts();
  usePromoCustomData(itemIds);

  return (<div />);
};

export default PromotionsProvider;
